<template>
  
  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-envelope text-primary mr-2"></i>
          Listado de Campañas
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">

          <b-card class="w-100">
            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
              Campañas
              <div>
                <button 
                :disabled="count<1" 
                class="btn btn-primary btn-sm mr-2" 
                @click="exportCampaigns('csv')">
                  <i class="fa fa-download"></i> CSV
                </button>
                <button 
                :disabled="count<1" 
                class="btn btn-primary btn-sm" 
                @click="exportCampaigns('xlsx')">
                  <i class="fa fa-download"></i> Excel
                </button>
                <button 
                :disabled="count<1" 
                class="btn btn-primary btn-sm ml-2" 
                @click="exportCampaigns('pdf')">
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row md="12" class="mb-3 border-top-primary px-2">
              <b-col class="col-md-9">
                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                  <b-form-input
                    id="string" 
                    name="string" 
                    type="text"
                    placeholder="Busqueda general"
                    v-model="entity.string" 
                    class="w-100"
                    v-validate="'min:3'" 
                    :state="validateState('string')"
                    aria-describedby="check_string"></b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first('string') }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col class="col-md-3">
                <button 
                class="btn btn-pill btn-primary ml-4 float-right" 
                @click="search">Buscar Campaña
              </button>
              </b-col>

            </b-row>

            <v-server-table
              :columns="columns" 
              :options="options" 
              :theme="theme"
              class="dataTable" 
              ref="dataCampaignTable"
              md="12" 
              lg="12" 
              sm="12" 
              @sorted="tableSorted">
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                </tr>
              </template>
              <template slot="uuid" slot-scope="props">
                <button 
                  v-b-tooltip.hover.top title="Editar Campaña" 
                  class="btn pr-1 pb-1 pl-1"
                  @click="$router.push('/communications/campaign/edit/' + props.row.uuid)">
                  <i class="fa fa-pencil"></i>
                </button>
                <button 
                  v-b-tooltip.hover.top title="Ver Estadísticas" 
                  class="btn pr-1 pb-1 pl-1"
                  @click="goToStatistics(props.row)">
                  <i class="fa fa-eye"></i>
                </button>
                <button 
                  v-b-tooltip.hover.top title="Duplicar Campaña" 
                  class="btn pr-1 pb-1 pl-1"
                  @click="duplicateCampaign(props.row.uuid)">
                  <i class="fa fa-copy"></i>
                </button>
                <button 
                  v-b-tooltip.hover.top title="Borrar Campaña" 
                  class="btn pr-1 pb-1 pl-1"
                  @click="deleteCampaign(props.row.uuid)">
                  <i class="fa fa-trash"></i>
                </button>
              </template>
            </v-server-table>
          </b-card>

        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import Vue from 'vue';
import form from '@/helpers/form';
import {ServerTable, Event} from 'vue-tables-2';
import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
import {downloadJsonAsPdf} from '@/helpers/js-pdf';
import Spinner from 'vue-simple-spinner';
import {deleteCampaign, getCampaign} from "@/api/campaign-api";

Vue.use(ServerTable);

export default {
  name: 'listCampaigns',
  components: { 
    Spinner 
  },
  data: function () {
    return {
      topmenu: [
        { 
          name: 'Inicio', 
          path: '/admin/dashboard', 
          brand: 'fa fa-home' 
        },
        { 
          name: 'Tipos de Campaña', 
          path: '/communications/campaign-type/list', 
          brand: 'fa fa-bookmark', 
          permissions: ['CAMPAIGN_TYPE_LIST'] 
        },
        { 
          name: 'Crear Campaña', 
          path: '/communications/campaign/add', 
          brand: 'fa fa-envelope', 
          permissions: ['CAMPAIGN_NEW'] 
        },
      ],
      entity: { 
        string: null, 
        page: 1, 
        itemsPerPage: 10,
      },
      orderBy: { 
        column: null, 
        ascending: null 
      },
      count: 0,
      loading: true,
      options: {
        headings: {
          uuid: { 
            text: '', 
            id: 'fit' 
          },
          createdAt: 'Fecha',
          name: 'Nombre',
          emailSent: 'Enviados',
          status: 'Estado',
        },
        requestFunction: data => {
          if (this.$store.getters.getFilters[0] !== null) {
            this.entity.string = this.$store.getters.getFilters[0];
          }
          this.entity.page = data.page;
          this.entity.itemsPerPage = data.limit;
          let self = this;
          const url = axios.defaults.baseURL + 'campaigns';
          return axios({ 
            url, 
            method: 'get', 
            params: this.searchFilters 
          }).catch(function (e) {
              self.dispatch('error', e);
            }.bind(this));
        },
        responseAdapter: ({data}) => {
          data.campaigns.forEach(campaign => {
            campaign.createdAt = new Date(campaign.createdAt).toISOString().split('T')[0];
            switch (campaign.status) {
              case 'Complete': 
              campaign.status = 'Completado'; 
              break;
              case 'Pending':  
              campaign.status = 'Pendiente';  
              break;
              case 'ToDo':     
              campaign.status = 'En Proceso'; 
              break;
            }
          });
          return { 
            data: data.campaigns, 
            count: data.count 
          }
        },
        columnsClasses: {uuid: "fit"},
        sortable: ['name'],
        filterable: false,
        sortIcon: { 
          base: 'fa', 
          up: 'fa-sort-asc', 
          down: 'fa-sort-desc', 
          is: 'fa-sort' 
        },
        perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
        texts: form.tableLabels(),
        pagination: { 
          chunk: 10, 
          edge: true, 
          nav: 'scroll' 
        }
      },
      columns: [
        'uuid', 
        'createdAt', 
        'name', 
        'emailSent', 
        'status'
      ],
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  mounted() {
    this.$_loadingMixin_showLoading();
    Event.$on('vue-tables.loading', () => {
      this.$_loadingMixin_showLoading();
      this.count = 0;
      this.loading = true;
      if (document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'none';
      }
    });
    Event.$on('vue-tables.loaded', (data) => {
      if (data && data.data && data.data.count) {
        this.count = data.data.count;
      }
      this.$_loadingMixin_hideLoading();
      this.loading = false;
      if (document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'table-row';
      }
    });

    this.$eventHub.$emit('captureMenu', this.topmenu);
  },
  computed: {
    searchFilters() {
      return {
        string: this.entity.string,
        page: this.entity.page,
        itemsPerPage: this.entity.itemsPerPage,
        orderColumn: this.orderBy.column,
        orderAscending: this.orderBy.ascending ? 1 : 0
      }
    }
  },
  methods: {
    goToStatistics(campaign) {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 7);
      this.$router.push({
        path: '/communications/statistics/statistics',
        query: { campaign: campaign.uuid }
      });
    },
    search() {
      this.$store.commit('SET_FILTERS_LIST', [this.entity.string]);
      this.$refs.dataCampaignTable.refresh();
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    normalizeCampaign(campaign) {
      return {
        'Fecha': new Date(campaign.createdAt).toLocaleDateString(),
        'Nombre': campaign.name,
        'Enviados': campaign.emailSent,
        'Estado': campaign.status,
      }
    },
    async exportCampaigns(format) {
      if (this.count > 0) {
        this.$_loadingMixin_showLoading();

        let response = await axios({
          method: 'get',
          url: axios.defaults.baseURL + 'campaigns',
          params: { 
            page: 1, 
            itemsPerPage: this.entity.itemsPerPage, 
            string: this.entity.string 
          }
        });

        let rows = response.data.campaigns.map(c => this.normalizeCampaign(c));

        if (format === 'csv') {
          downloadJsonAsCsv(rows);
        } else if (format === 'xlsx') {
          downloadJsonAsXlsx(rows);
        } else if (format === 'pdf') {
          downloadJsonAsPdf(rows);
        }

        this.$_loadingMixin_hideLoading();
      }
    },
    tableSorted(data) {
      this.orderBy.column = data.column;
      this.orderBy.ascending = data.ascending;
    },
    async deleteCampaign(campaignId) {
      swal({
        title: '¿Estás seguro de eliminar la Campaña seleccionada?',
        text: "Esta operación no se podrá revertir",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, elimínalo!'
      }).then((result) => {
        if (result.value) {

          this.$_loadingMixin_showLoading();

          deleteCampaign(campaignId)
            .then(() => { 
              this.search(); 
            })
            .catch(() => { 
              this.$_notificationMixin_error('Error en la operación', 'No se ha borrado la Campaña'); 
            });

          this.$_loadingMixin_hideLoading();

        }
      });
    },
    async duplicateCampaign(campaignId) {
      try {
        this.$_loadingMixin_showLoading();
        const campaignData = await getCampaign(campaignId);

        const campaign = campaignData.campaign || campaignData;

        if (!campaign || !campaign.name) {
          throw new Error('Estructura de datos de campaña inválida');
        }

        const duplicateData = {
          name:              campaign.name + ' (Copia)',
          html:              campaign.html || '',
          publishedAt:       new Date().toISOString(), 
          senderName:        campaign.senderName || null,
          sender:            campaign.sender || null,
          responder:         campaign.responder || null,
          distributionLists: (campaign.distributionLists || []).map(d => ({ uuid: d.uuid, name: d.name })),
          campaignTypes:     (campaign.campaignTypes || []).map(c => ({ uuid: c.uuid, name: c.name })),
        };

        const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(duplicateData))));

        this.$_loadingMixin_hideLoading();
        this.$router.push({
          path: '/communications/campaign/add',
          query: { duplicate: encoded }
        });
      } catch (error) {
        this.$_loadingMixin_hideLoading();
        console.error('Error al duplicar campaña:', error);
        this.$_notificationMixin_error('Error en la operación', 'No se ha podido obtener los datos de la Campaña');
      }
    },
  },
}
</script>

<style lang="scss">
.VueTables__no-results {
  display: none;
}
</style>
